import styled from "styled-components";

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    gap: 10px;

    h2 {
      text-align: center;
      margin-bottom: 20px;
    }

    .section {
      margin-bottom: 20px;
    }

    .section h3 {
      color: #333;
      margin-bottom: 10px;
    }

    .section p {
      margin-bottom: 8px;
    }

    ol {
      list-style-position: inside;
    }

    ol li {
      margin-bottom: 5px;
    }
`;

export const AddedField = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2px;
`;

export const ContentField = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  justify-content: space-between;
  align-itens: center;
`;

export const FormField = styled.div`
  display: flex;
  width: 70%;
`;

export const ButtonField = styled.div`
  display: flex;
  width: 20%;
`;

